const ORIENTATION = {
  /**
   * 需要顺时针旋转180度
   */
  '180': 3,
  /**
   * 需要顺时针旋转90度
   */
  '90': 6,
  /**
   * 需要逆时针旋转90度
   */
  '-90': 8
}

interface IProps {
  src: string;
  /**
   * 图片原尺寸
   */
  sWidth: number;
  sHeight: number;
  /**
   * 裁剪后输出的图片尺寸
   */
  width: number;
  height: number;
  /**
   * 裁剪后输出的图片类型
   */
  type?: string;
  orientation?: number;
}

class CropImage {
  private canvas?: HTMLCanvasElement | null;
  private cropImage: HTMLImageElement;
  private type: string;
  private orientation: number | undefined;
  private sWidth: number;
  private sHeight: number;
  private width: number;
  private height: number;

  crop = async (props: IProps) => {
    const { src } = props;
  
    this.type = `image/${props.type || 'jpeg'}`;
    this.orientation = props.orientation;
    this.sWidth =  Math.floor(props.sWidth);
    this.sHeight =  Math.floor(props.sHeight);
    this.width =  Math.floor(props.width);
    this.height =  Math.floor(props.height);

    this.canvas = document.createElement('canvas');
    this.canvas.width =  this.width;
    this.canvas.height = this.height;
    await this.initCropImage(src);

    return this.handleCrop();
  }

  /**
   * 加载多一次没容器限制的图片，用于裁剪，防止在裁剪过程中被截断
   */
  initCropImage = (src: string) => {
    return new Promise((resolve) => {
      this.cropImage = new Image();
      this.cropImage.onload = () => {
          resolve(true);
      };
      this.cropImage.src = src;
    });
  }

  handleCrop = () => {
    const { cropImage, canvas, type } = this;
    const ctx = canvas && canvas.getContext('2d');
    if (!cropImage || !cropImage.complete || !canvas || !ctx || !type) {
      return '';
    }

    this.handleCtxDrawImage(ctx, cropImage);
    // const compressRate = 0.8;
    // const dataURL = canvas.toDataURL(type, compressRate);

    return canvas;
  }


  /**
   * 获取裁剪框与头像交集区域的裁剪参数
   */
  getCropParams = () => {
    const { sWidth, sHeight, width, height } = this;
   
    return {
      sX: 0,
      sY: 0,
      sWidth: sWidth,
      sHeight: sHeight,
      dX: 0,
      dY: 0,
      dWidth: width,
      dHeight: height,
    }
  }

  /**
   * 解决图片裁剪后，会自动旋转的问题，主要针对IOS
   */
  handleCtxDrawImage = (ctx: CanvasRenderingContext2D, image: HTMLImageElement) => {
    const { orientation } = this;
    const {sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight} = this.getCropParams();
    ctx.save();
    // 换算成画布旋转前的坐标，参考https://juejin.im/post/5d9b176af265da5b6f073537
    switch(orientation) {
      case ORIENTATION['90']:
        ctx.rotate(Math.PI / 2);
        ctx.drawImage(image, sX, sY, sHeight, sWidth, dY, -dWidth, dHeight, dWidth);
        break;
      case ORIENTATION['-90']:
        ctx.rotate(-Math.PI / 2);
        ctx.drawImage(image, sX, sY, sHeight, sWidth, -dHeight, dX, dHeight, dWidth);
        break;
      case ORIENTATION['180']:
        ctx.rotate(Math.PI);
        ctx.drawImage(image, sX, sY, sWidth, sHeight, -dWidth, -dHeight, dWidth, dHeight);
        break;
      default:
        ctx.drawImage(image, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);
        break;
    }
    ctx.restore();
  }

}


export const cropImageUtil = new CropImage();

